// extracted by mini-css-extract-plugin
export default {"emptyCart":"EmptyCart_emptyCart__o+354"};